import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/bd-mobile-next/app/(main)/hottest-deals/page.tsx");
